// JS
import React from 'react';
import { getPercentPrice, calculateSaleDiscount } from '../shared/utils';

// COMP
const DiscountPrice = ({ isSale, data, text }) => {
  return (
    <>
      {data && data.product.option.onsale && (
        <div
          className={`p-2 bg-red-600 inline-block text-white pointer-events-none text-sm font-basemedium rounded-sm z-10 leading-5 tracking-normal w-fit ${
            isSale &&
            '!bg-[#DA0018] !p-4 !text-lg !font-bold !tracking-[1.08px] !uppercase'
          }`}
        >
          {isSale
            ? calculateSaleDiscount(data.product) + ' ' + text
            : text + ' ' + getPercentPrice(data.product) + '%'}
        </div>
      )}
    </>
  );
};

export default DiscountPrice;
